import useSWR from 'swr'

// libs
import { apiGetService, apiHandleError } from '@/lib'

// types
import { SWRKeys, SWRFetcherData } from './types'

const getUser = async ({ data: { userId } }: SWRFetcherData<{ userId: string }>) => {
  // get api service
  const api = apiGetService()

  try {
    // retrieve user
    const { user } = await api.userApi.getUser(userId)

    // return payload
    return { user, error: '' }
  } catch (err: any) {
    const { message } = await apiHandleError(err)

    // return payload
    return { user: undefined, error: message }
  }
}

const fetcher = (args: SWRFetcherData<{ userId: string }>) => getUser(args)

export const useUser = (userId: string) => {
  const shouldFetch = !!userId

  const { data, isLoading, mutate } = useSWR(
    shouldFetch ? { key: SWRKeys.UseUser, data: { userId } } : null,
    fetcher,
    { revalidateOnFocus: false },
  )

  return {
    user: data?.user,
    isLoading,
    isError: data?.error,
    mutate,
  }
}
